import {WorkOrder} from '@domain/work-orders'
import {WorkOrderStatusLabel} from '@hconnect/common/components/eventProperties'
import {PriorityTitle} from '@hconnect/common/components/shiftEventFormFields'
import {Tag} from '@hconnect/common/components/Tag'
import {DateFormat} from '@hconnect/uikit/src/common/components'
import {Grid} from '@mui/material'
import {getEquipmentLabelDetails} from '@widgets/common-shift-event'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

const regularSize = {xs: 12, sm: 6}

interface WorkOrderDetailsGridProps {
  item: WorkOrder
  timezone: string
}

export const WorkOrderDetailsGrid = ({item, timezone}: WorkOrderDetailsGridProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Grid
      container
      sx={{
        my: 1.5
      }}
      spacing={2}
    >
      <Grid item {...regularSize} data-test-id="event-detail-priority">
        <Tag label={t('shiftEvent.label.priority')}>
          {!item.priority ? (
            t('shiftEvent.action.noneOfThat')
          ) : (
            <PriorityTitle priority={item.priority} />
          )}
        </Tag>
      </Grid>
      <Grid item {...regularSize}>
        <Tag label={t('shiftEvent.label.status')} data-test-id="event-detail-status">
          {item.status && <WorkOrderStatusLabel status={item.status} />}
        </Tag>
      </Grid>
      {item.orderType && (
        <Grid item {...regularSize}>
          <Tag label={t('shiftEvent.label.orderType')} data-test-id="event-detail-orderType">
            {`${t(`sapWorkOrderTypes.${item.orderType}`, item.orderType)} (${item.orderType})`}
          </Tag>
        </Grid>
      )}
      <Grid item {...regularSize}>
        <Tag label={t('shiftEvent.label.responsible')} data-test-id="event-detail-responsible">
          {item.responsible?.name ?? '-'}
        </Tag>
      </Grid>
      <Grid item {...regularSize}>
        <Tag
          label={t('shiftEvent.label.functionalLocation')}
          data-test-id="event-detail-functionalLocation"
        >
          {getEquipmentLabelDetails(item.functionalLocation)}
        </Tag>
      </Grid>
      <Grid item xs={6}>
        <Tag label={t('shiftEvent.label.startDate')} data-test-id="event-detail-startDate">
          {item.startDate ? <DateFormat date={item.startDate} timezone={timezone} /> : '-'}
        </Tag>
      </Grid>
      <Grid item xs={6}>
        <Tag label={t('shiftEvent.label.endDate')} data-test-id="event-detail-endDate">
          {item.endDate ? <DateFormat date={item.endDate} timezone={timezone} /> : '-'}
        </Tag>
      </Grid>
      <Grid item xs={12}>
        <Tag data-test-id="event-detail-equipment" label={t('shiftEvent.label.equipment')}>
          {getEquipmentLabelDetails(item.equipment)}
        </Tag>
      </Grid>
      <Grid item {...regularSize}>
        <Tag label={t('shiftEvent.label.workCenter')} data-test-id="event-detail-workCenter">
          {item.workCenter ?? '-'}
        </Tag>
      </Grid>
      <Grid item {...regularSize}>
        <Tag label={t('shiftEvent.label.costCenter')} data-test-id="event-detail-costCenter">
          {item.costCenter ?? '-'}
        </Tag>
      </Grid>
      <Grid item {...regularSize}>
        <Tag label={t('shiftEvent.label.profitCenter')} data-test-id="event-detail-profitCenter">
          {item.profitCenter ?? '-'}
        </Tag>
      </Grid>
      <Grid item {...regularSize}>
        <Tag label={t('shiftEvent.label.activityType')} data-test-id="event-detail-activityType">
          {item.activityType ?? '-'}
        </Tag>
      </Grid>
      <Grid item {...regularSize}>
        <Tag label={t('shiftEvent.label.duration')} data-test-id="event-detail-duration">
          {item.duration ?? '-'}
        </Tag>
      </Grid>
    </Grid>
  )
}
